import { render, staticRenderFns } from "./CustomerActionFilterItemList.vue?vue&type=template&id=24b04cd1&scoped=true"
import script from "./CustomerActionFilterItemList.vue?vue&type=script&lang=js"
export * from "./CustomerActionFilterItemList.vue?vue&type=script&lang=js"
import style0 from "./CustomerActionFilterItemList.vue?vue&type=style&index=0&id=24b04cd1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b04cd1",
  null
  
)

export default component.exports